import React, { useEffect, useRef } from 'react';

import { logAmplitudeEvent } from '~app/pages/Pricing/pages/shared';
import { AMPLITUDE_PAGE_EVENTS } from '~shared/util';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';

export default function AdaChatBot(): JSX.Element {
  const ADA_SCRIPT = 'https://static.ada.support/embed2.js';
  const ADA_HANDLE = 'surveymonkey';
  const ADA_ID = 'ada-entry';
  const { pageName } = useTrackingDetails();
  const ADA_IFRAME = useRef<HTMLScriptElement | null>(document.getElementById(ADA_ID) as HTMLScriptElement | null);

  useEffect(() => {
    const isTeamsPage =
      pageName === 'pricing details teams' ||
      pageName === 'pricing summary teams' ||
      pageName === 'pricing summary canonical';

    // Load script on pricing details
    if (!ADA_IFRAME.current && isTeamsPage) {
      // Creating ADA script
      ADA_IFRAME.current = document.createElement('script');
      ADA_IFRAME.current.id = '__ada';
      ADA_IFRAME.current.setAttribute('data-handle', ADA_HANDLE);
      ADA_IFRAME.current.src = ADA_SCRIPT;
      ADA_IFRAME.current.setAttribute('data-status', 'loading');
      ADA_IFRAME.current.async = true;

      ADA_IFRAME.current.onload = (): void => {
        logAmplitudeEvent({
          eventName: 'ada chatbot loaded',
          pageName,
          amplitudeEvent: AMPLITUDE_PAGE_EVENTS.experimentEvent,
        });
      };

      ADA_IFRAME.current.onerror = (): void => {
        logAmplitudeEvent({
          eventName: 'ada chatbot error loading',
          pageName,
          amplitudeEvent: AMPLITUDE_PAGE_EVENTS.experimentEvent,
        });
      };

      // Append ADA script to body and execute
      document.body.appendChild(ADA_IFRAME.current);

      // Removing the ada script after execution/mount .. just incase there are side effects of keeping it around
      return () => {
        if (ADA_IFRAME.current) {
          document.body.removeChild(ADA_IFRAME.current);
        }
      };
    }
    // Hide script on all other pages
    if (ADA_IFRAME.current && !isTeamsPage) {
      ADA_IFRAME.current.style.display = 'none';
    } else if (ADA_IFRAME.current && isTeamsPage) {
      // Show script on teams
      ADA_IFRAME.current.style.display = 'block';
    }
    return undefined;
  }, [pageName]);

  return <></>;
}
